import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

export const EditPatchNote = ({ data, displayed, onClose, onSave }) => {
  const start = new Date(data.startAt);
  const [updateLink, setUpdateLink] = useState(data.link);

  const handleChangeLink = (event) => {
    setUpdateLink(event.target.value);
  };
  return (
    <Dialog
      open={displayed}
      onClose={() => {
        onClose();
        setUpdateLink(null);
      }}
      maxWidth="md"
    >
      <DialogTitle
        sx={{
          borderBottom: 1,
          marginBottom: 3,
          display: 'flex',
          gap: 4,
          alignItems: 'center',
          fontSize: 24,
          color: 'primary.main',
        }}
      >
        {data.releaseNumber}
      </DialogTitle>
      <DialogContent
        sx={{
          maxHeight: '75vh',
          minWidth: '80vh',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography>Lien vers les détails de la patch note</Typography>
          <TextField
            multiline
            rows={4}
            type="url"
            variant="outlined"
            value={updateLink}
            onChange={handleChangeLink}
            fullWidth
            placeholder={data.link}
          />
          <Divider sx={{ my: 1 }} />
          {`Déploiement du ${start?.toLocaleString('fr')} par ${data.author?.firstName} ${data.author?.lastName}`}
        </Box>
      </DialogContent>
      <DialogActions
        sx={{ p: 3, display: 'flex', justifyContent: 'space-between' }}
      >
        <Button
          variant="outlined"
          color="info"
          onClick={() => {
            onClose();
            setUpdateLink(null);
          }}
          sx={{ marginRight: 2 }}
        >
          Annuler
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            onSave(updateLink);
            setUpdateLink(null);
          }}
          sx={{ marginRight: 2 }}
        >
          Sauvegarder
        </Button>
      </DialogActions>
    </Dialog>
  );
};
